export const paths = {
  user: '/api/v1/me',
  userRequisites: '/api/v1/me/requisites'
}